import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import {
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
  MatSnackBar,
} from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Subscription, take, finalize } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';
import { UniqueIdService } from '../../services/unique-id/unique-id.service';
import { ValidationsService } from '../../services/validations/validations.service';
import { AlertComponent } from '../alert/alert.component';
import { LoadingService } from '../loading/loading.service';
import { UserService } from '../../services/user/user.service';
import { customEmailValidator } from '../../shared/validators/email-validator';

@Component({
  selector: 'app-recuperar-senha',
  templateUrl: './recuperar-senha.component.html',
  styleUrls: ['./recuperar-senha.component.scss'],
})
export class RecuperarSenhaComponent implements AfterViewChecked, OnDestroy {
  hide = true;
  isValidCPF: boolean = false;
  isValidSenha: boolean = false;
  public id: string;
  subsctiptions: Subscription[] = [];
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  emailSent: boolean = false;
  email: string = '';
  form: FormGroup;
  emailNaoLocalizado = false;
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private uniqueIdService: UniqueIdService,
    private _snackBar: MatSnackBar,
    private validationsService: ValidationsService,
    private loadingService: LoadingService,
    private router: Router,
    private fb: FormBuilder,
    private userService: UserService
  ) {
    this.id =
      this.uniqueIdService.generateUniqueIdWithPrefix('recuperar-senha');

    this.form = this.fb.group({
      email: [null, [Validators.required,Validators.email]],
    });
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  onLogin() {
    const value = this.form.value;
    this.loadingService.showLoading();

    this.subsctiptions.push(
      this.userService
        .sendEmailRecovery(value)
        .pipe(
          take(1),
          finalize(() => {
            this.loadingService.hideLoading();
          })
        )
        .subscribe(
          (resp) => {

            this.emailSent = true;
          },
          (erro) => {
            if (erro.status !== 500 && erro.status) {
              this.emailNaoLocalizado = true;
              // this.openSnackBar(erro.error.message, 'error');
            } else {
              this.openSnackBar(
                'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
                'error'
              );
            }
          }
        )
    );
  }

  validateCPFInput(event: any) {
    const inputValue = event.target?.value;
    if (inputValue) {
      this.isValidCPF = this.validationsService.validarCPF(inputValue);
    }
  }

  validarSenha(event: any): boolean {
    const isValidPassword = this.validationsService.validarSenha(event);
    this.isValidSenha = isValidPassword;
    return isValidPassword;
  }

  openSnackBar(description: string, type: string) {
    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: ['snackbar'],
      data: { description: description, type: type },
      horizontalPosition: 'end',
      verticalPosition: 'top',
    });
  }
  goToLogin() {
    this.router.navigate(['/login']);
  }

  ngOnDestroy(): void {
    this.subsctiptions.forEach((sub) => sub.unsubscribe());
  }

}
